<canvas ref="assetSummaryChart"></canvas>

<script>
import { Bar } from "vue-chartjs";

export default {
  name: "AssetSummaryChart",
  extends: Bar,
  props: {
    data: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      default: () => ["Hires", "Dehires", "In-Transit"],
    },
  },
  watch: {
    data: "renderBarChart",
    labels: "renderBarChart",
  },
  mounted() {
    this.renderBarChart();
  },
  methods: {
    renderBarChart() {
      const chartData = {
        labels: [""],
        datasets: [
          {
            label: this.labels[0],
            data: [this.data[0]],
            backgroundColor: "#FFF6ADCC",
          },
          {
            label: this.labels[1],
            data: [this.data[1]],
            backgroundColor: "#FF8C8CCC",
          },
          {
            label: this.labels[2],
            data: [this.data[2]],
            backgroundColor: "#B7E2C5CC",
          },
        ],
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
          text: "Asset Classification Summary",
          fontSize: 18,
          fontColor: "#333",
          position: "top",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMax: 50,
                beginAtZero: true, // This ensures the y-axis starts at 0
                callback: function (value) {
                  if (value >= 1000000) return value / 1000000 + "M";
                  if (value >= 1000) return value / 1000 + "K";
                  return value;
                },
              },
            },
          ],
          xAxes: [
            {
              stacked: false,
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          position: "bottom",
          labels: {
            fontColor: "#333",
            usePointStyle: true,
          },
        },
      };

      this.renderChart(chartData, chartOptions);
    },
  },
};
</script>

<style scoped>
canvas {
  height: 250px !important;
}
</style>
